import clsx from 'clsx';

type AdminRoleBadgeProps = {
  label: string;
  color: string;
};

/** 色ドット + ラベルで権限を表示する */
export default function AdminRoleBadge({ label, color }: AdminRoleBadgeProps) {
  return (
    <span className="flex items-center gap-2 font-bold text-black">
      <span className={clsx('size-2 rounded-full', color)} />
      {label}
    </span>
  );
}
